import { payRequestIdZodSchema } from "@@/shared/pay-requests/pay-request-id";
import type { Except } from "type-fest";
import { z } from "zod";
import {
    paymentCancellationIdFactory,
    paymentCancellationIdZodSchema,
} from "./payment-cancellation-id";

const payRequestPaymentCancellationZodObject = z.object({
    _id: paymentCancellationIdZodSchema,
    _type: z.literal("MANAGE_PAYMENT_CANCELLATION"),
    type: z.literal("PAY_REQUEST"),
    payRequestId: payRequestIdZodSchema,
});
type PayRequestPaymentCancellation = z.infer<
    typeof payRequestPaymentCancellationZodObject
>;

type FactoryParams = Except<
    PayRequestPaymentCancellation,
    "_id" | "_type" | "type"
>;
const payRequestPaymentCancellationFactory = (params: FactoryParams) => {
    const replacement: PayRequestPaymentCancellation = {
        ...params,
        _id: paymentCancellationIdFactory(),
        _type: "MANAGE_PAYMENT_CANCELLATION",
        type: "PAY_REQUEST",
    };
    return replacement;
};

export {
    payRequestPaymentCancellationFactory,
    payRequestPaymentCancellationZodObject,
};
export type { PayRequestPaymentCancellation };
